var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M637.77,117.56a51.51,51.51,0,0,1,11.14,7.85l11.91-4.23L672,138.84l-8.91,9a51.1,51.1,0,0,1,2.33,13.43l11.42,5.42-4.58,20.4-12.63,0a51.51,51.51,0,0,1-7.86,11.15l4.24,11.9-17.66,11.19-9-8.91A51.51,51.51,0,0,1,616,214.74l-5.42,11.42-20.41-4.58,0-12.63A51.51,51.51,0,0,1,579,201.09l-11.91,4.24-11.19-17.66,8.92-9a51.94,51.94,0,0,1-2.34-13.43L551,159.86l4.58-20.4,12.63,0a51.27,51.27,0,0,1,7.86-11.15l-4.24-11.9,17.66-11.19,9,8.91a51.51,51.51,0,0,1,13.43-2.33l5.42-11.42,20.4,4.58,0,12.63Zm-18,24a22.43,22.43,0,1,0,17,26.8A22.43,22.43,0,0,0,619.78,141.57Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.53,78.51a12.64,12.64,0,0,1,3.91,1.23,16.46,16.46,0,0,1,7.81,7.89,16.62,16.62,0,0,1,1.59,7.63,17,17,0,0,1-2.62,8.56,17,17,0,0,1-7.5,6.43,16.92,16.92,0,0,1-19.64-4.4,17.06,17.06,0,0,1-4-9A16.91,16.91,0,0,1,506.34,88a16.73,16.73,0,0,1,4.7-6.22A16.48,16.48,0,0,1,521.47,78a12.6,12.6,0,0,1,4.06.56c0,.12-1.45-.29-4-.19a16.46,16.46,0,0,0-10,4,16.14,16.14,0,0,0-5.54,14.45,15,15,0,0,0,1.26,4.45,15.21,15.21,0,0,0,2.6,4.07,16,16,0,0,0,18.56,4.16,16.19,16.19,0,0,0,7.13-6.06,16.28,16.28,0,0,0,2.57-8.11,16.11,16.11,0,0,0-1.41-7.32,16.55,16.55,0,0,0-7.36-7.84C527,78.87,525.5,78.62,525.53,78.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.81,60.79a5.08,5.08,0,0,1,0-.59c0-.43,0-1,0-1.76q0-2.43-.09-7l.12.15-15.09-3.3.27-.13-4,8.44-.07.16h-.17a38.17,38.17,0,0,0-9.84,1.75l-.18.06-.13-.14L503,51.89l.42,0-13,8.29.15-.44c1,2.72,2.05,5.72,3.15,8.79l.08.22-.17.18a37.43,37.43,0,0,0-5.72,8.15l-.11.22h-.25l-9.33,0,.42-.33c-1.06,4.73-2.2,9.84-3.36,15.07l-.25-.5,8.43,4,.25.11V96a37.75,37.75,0,0,0,1.71,9.79l.09.27-.2.19-6.58,6.62.06-.58c2.62,4.13,5.43,8.55,8.27,13l-.56-.19,8.79-3.13.28-.1.21.19a37.08,37.08,0,0,0,8.11,5.72h0l.26.42h0v9.32l-.37-.47,15.07,3.39-.53.25q2-4.25,4-8.42l.13-.26h.28a37.28,37.28,0,0,0,9.79-1.7l.27-.08.2.2,6.6,6.59L539,137l13-8.24-.18.51c-1.06-3-2.09-5.91-3.12-8.79l-.08-.25.17-.19a37.39,37.39,0,0,0,5.75-8.12l.11-.22h9.58l-.39.31c1.2-5.3,2.34-10.3,3.41-15.06l.2.41-8.41-4-.19-.09V93a37.68,37.68,0,0,0-1.68-9.83l-.06-.18.14-.14,6.6-6.59,0,.35-8.2-13.07.25.08-8.81,3.08-.09,0-.07-.07a38.73,38.73,0,0,0-6-4.61l-1.6-1a5.56,5.56,0,0,1-.53-.32,4.14,4.14,0,0,1,.57.25c.37.19.92.48,1.64.9a37,37,0,0,1,6.12,4.53l-.15,0,8.77-3.19.16-.06.09.15,8.32,13,.12.19-.16.16c-2,2-4.18,4.22-6.56,6.64l.07-.32a38,38,0,0,1,1.77,10l-.19-.3,8.44,4,.26.13-.07.28c-1,4.77-2.17,9.77-3.34,15.07l-.07.31h-.32l-9.33,0,.37-.22a38.1,38.1,0,0,1-5.85,8.32l.09-.43q1.53,4.32,3.14,8.79l.11.33-.29.19-13,8.27-.31.19-.25-.25-6.62-6.58.46.11a37.88,37.88,0,0,1-10,1.75l.41-.26-4,8.43-.16.34-.37-.09L503.55,138l-.37-.08v-.38c0-1.55,0-3.1,0-4.65v-4.67h0c.51.84.14.23.25.42h0a38.78,38.78,0,0,1-8.32-5.87l.48.1L486.77,126l-.36.12-.2-.32-8.25-13-.2-.31.26-.27,6.59-6.61-.11.47a38.38,38.38,0,0,1-1.74-10l.25.39-8.42-4-.32-.15.08-.35,3.4-15,.07-.34h9.67l-.36.22A38.08,38.08,0,0,1,493,68.43l-.08.4L489.8,60l-.1-.28.26-.16L503,51.36l.23-.14.19.19C505.75,53.72,508,56,510,58l-.32-.08a38.05,38.05,0,0,1,10-1.7l-.24.15c1.46-3,2.82-5.86,4-8.4l.08-.18.19,0,15,3.47.12,0v.12q0,4.5-.06,6.92c0,.76,0,1.35,0,1.79A5.31,5.31,0,0,1,538.81,60.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.33,280.93a26.3,26.3,0,0,1,4.93,4.84l6.31-1.15,4.15,9.75-5.19,3.75a25.76,25.76,0,0,1,.08,6.91l5.27,3.64-3.95,9.84-6.33-1a26,26,0,0,1-4.83,4.94l1.15,6.3-9.75,4.16-3.75-5.19a25.77,25.77,0,0,1-6.91.07L110.87,333l-9.84-4,1-6.32a25.76,25.76,0,0,1-4.94-4.84l-6.3,1.15-4.16-9.75,5.19-3.75a25.77,25.77,0,0,1-.07-6.91L86.5,295l4-9.83,6.32,1a25.76,25.76,0,0,1,4.84-4.94l-1.15-6.3,9.74-4.16L114,276a26.18,26.18,0,0,1,6.91-.07l3.64-5.27,9.83,3.95-1,6.32Zm-11,10.55a11.37,11.37,0,1,0,6.31,14.79A11.37,11.37,0,0,0,122.37,291.48Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.37,291.48a8.79,8.79,0,0,1,2.52,1.26,11.31,11.31,0,0,1,4.42,6.21,11.6,11.6,0,0,1,.24,5.35,11.74,11.74,0,0,1-2.73,5.51,11.7,11.7,0,0,1-5.78,3.53,11.63,11.63,0,0,1-12.83-5.15,11.37,11.37,0,0,1-1.37-3.22,10.91,10.91,0,0,1-.36-3.34,11.71,11.71,0,0,1,1.85-5.86,11.49,11.49,0,0,1,11.35-5.12,8.58,8.58,0,0,1,2.69.83c0,.08-1-.35-2.72-.58a11.31,11.31,0,0,0-7.22,1.58,11.1,11.1,0,0,0-3.65,3.58,11.28,11.28,0,0,0-1.7,5.59,10.7,10.7,0,0,0,.36,3.16,10.36,10.36,0,0,0,1.32,3,11,11,0,0,0,12.12,4.87,11.17,11.17,0,0,0,5.5-3.32,11.13,11.13,0,0,0,2.48-10.32,11.33,11.33,0,0,0-4.12-6.13A26.71,26.71,0,0,0,122.37,291.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.33,280.93a1.68,1.68,0,0,1,0-.39c0-.3.09-.69.17-1.2.16-1.1.39-2.69.7-4.74l.06.11-9.85-3.9.19-.06c-1.09,1.61-2.31,3.38-3.61,5.29l-.07.09h-.12a25.49,25.49,0,0,0-6.85.1l-.13,0-.08-.11L110,271l.27.08-9.73,4.18.15-.28c.36,1.95.76,4.09,1.16,6.3l0,.16-.13.1A25.81,25.81,0,0,0,97,286.38l-.1.14-.17,0-6.33-1,.32-.18c-1.24,3.09-2.57,6.43-3.94,9.84l-.11-.36,5.27,3.64.16.1,0,.19a26.05,26.05,0,0,0,.08,6.82l0,.19-.15.12-5.19,3.75.1-.38L91.11,319l-.36-.19,6.3-1.15.2,0,.12.15a25.65,25.65,0,0,0,4.87,4.77h0c.06.14-.12-.31.13.32h0V323l0,.2-.07.4-.12.79-.26,1.59c-.17,1.05-.34,2.11-.51,3.15l-.2-.35,9.84,3.95-.39.12,3.64-5.27.11-.16.2,0a25.1,25.1,0,0,0,6.82-.07l.19,0,.11.15,3.75,5.2-.37-.11,9.75-4.15-.18.33q-.57-3.21-1.14-6.3l0-.18.14-.1a26,26,0,0,0,4.79-4.88l.1-.14.17,0,6.32,1-.3.16,4-9.82.09.3-5.26-3.66-.12-.08,0-.14a26,26,0,0,0-.06-6.85l0-.13.11-.07,5.2-3.74-.06.23c-1.6-3.78-3-7-4.12-9.76l.16.08-6.31,1.11h-.06l0-.05a26.36,26.36,0,0,0-3.55-3.78l-1-.84c-.23-.18-.33-.27-.32-.28l.35.24c.23.17.58.43,1,.79a26.13,26.13,0,0,1,3.65,3.74l-.11,0,6.3-1.2.11,0,0,.11,4.2,9.73.06.14-.12.09-5.18,3.77.09-.2a26.05,26.05,0,0,1,.09,7l-.1-.22,5.28,3.63.17.11-.08.18c-1.24,3.12-2.55,6.38-3.93,9.85l-.08.2-.22,0-6.32-1,.27-.11a26.21,26.21,0,0,1-4.88,5l.11-.29q.57,3.11,1.15,6.3l0,.24L135,329l-9.75,4.17-.22.1-.15-.2-3.76-5.19.3.13a26.36,26.36,0,0,1-7,.08l.3-.14q-1.8,2.61-3.64,5.27l-.14.22-.24-.1-9.84-3.95-.24-.09,0-.26.51-3.15.25-1.59.13-.79.06-.4,0-.2,0-.1v-.08h0c.25.62.07.17.12.31h0a25.75,25.75,0,0,1-5-4.89l.31.12-6.3,1.15-.26.05-.1-.24c-1.43-3.35-2.84-6.66-4.15-9.75l-.1-.24.2-.15,5.2-3.75-.13.31a26.55,26.55,0,0,1-.07-7l.13.3-5.26-3.65-.2-.14.09-.22c1.37-3.42,2.71-6.75,4-9.83l.09-.22.23,0,6.32,1-.27.11a26.29,26.29,0,0,1,4.89-5l-.1.26c-.4-2.2-.78-4.35-1.14-6.3l0-.2.19-.08,9.75-4.14.17-.07.11.15,3.74,5.2-.2-.09a26.22,26.22,0,0,1,7-.05l-.18.08,3.66-5.25.08-.11.12.05,9.81,4,.08,0v.08l-.81,4.68c-.09.51-.17.91-.22,1.21A2.39,2.39,0,0,1,133.33,280.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.94,334.08a45.34,45.34,0,0,1,8.64,8.47l11-2,7.29,17.08-9.1,6.58a45.41,45.41,0,0,1,.14,12.11l9.23,6.38-6.93,17.23-11.08-1.78a45.11,45.11,0,0,1-8.47,8.65l2,11-17.08,7.29L196.06,416a45.84,45.84,0,0,1-12.11.13l-6.37,9.23-17.24-6.92,1.78-11.08a45.45,45.45,0,0,1-8.65-8.48l-11.05,2-7.28-17.08,9.09-6.58a45.85,45.85,0,0,1-.13-12.11l-9.23-6.38,6.92-17.23,11.08,1.78a45.45,45.45,0,0,1,8.48-8.65l-2-11.05,17.08-7.29,6.58,9.1a45.43,45.43,0,0,1,12.11-.13l6.38-9.23L218.71,323l-1.77,11.08Zm-19.2,18.48a19.93,19.93,0,1,0,11.06,25.92A19.93,19.93,0,0,0,197.74,352.56Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--JavaScript--inject-71"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "216.18 224.08 95.65 224.08 95.65 74.18 187.85 74.45 216.18 105.22 216.18 224.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.7,159.7c-.15.15-2.15-1.66-5.26-4.7s-7.34-7.32-11.94-12.12l-.51-.54.51-.54,0-.05c4.58-4.83,8.79-9.15,11.9-12.22s5.1-4.9,5.25-4.75-1.55,2.24-4.45,5.51-7,7.7-11.57,12.54l-.05,0V141.8c4.6,4.8,8.69,9.2,11.6,12.44S131.86,159.55,131.7,159.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.07,124.78c.16-.15,2.16,1.66,5.27,4.7s7.34,7.32,11.93,12.12l.52.54-.51.54-.05,0c-4.59,4.84-8.8,9.15-11.9,12.22s-5.1,4.9-5.26,4.75,1.56-2.24,4.46-5.51,7-7.7,11.56-12.53l0-.06v1.08c-4.59-4.8-8.69-9.2-11.6-12.43S179.92,124.93,180.07,124.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.22,165.21c-.36-.22,5.89-11.12,14-24.34s14.93-23.75,15.3-23.52-5.88,11.12-14,24.34S141.59,165.44,141.22,165.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.84,74.46l-.11,25.11a6.46,6.46,0,0,0,6.65,6.48l21.8-.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.58,
    y: 175.72,
    width: 53.45,
    height: 32.49,
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.77,198.61,98.16,197a4.19,4.19,0,0,0,3.5,2c1.89,0,2.87-1.15,2.87-3.41v-9.42H98.47v-2.08h8.44v11.38c0,3.74-1.82,5.59-5.25,5.59A5.87,5.87,0,0,1,96.77,198.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.26,198.92l.89-1.87a8.6,8.6,0,0,0,5.53,1.94c2.91,0,4.15-1.13,4.15-2.59,0-4.1-10.16-1.51-10.16-7.74,0-2.59,2-4.8,6.42-4.8a9.88,9.88,0,0,1,5.4,1.49l-.8,1.92a8.6,8.6,0,0,0-4.6-1.37c-2.85,0-4.07,1.2-4.07,2.66,0,4.1,10.16,1.54,10.16,7.7,0,2.56-2.06,4.77-6.5,4.77A10,10,0,0,1,110.26,198.92Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Angular--inject-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.9,83.05a7.92,7.92,0,0,0-4.37,7.17l.38,59.47a7.92,7.92,0,0,0,3.84,6.79l49.38,29.43h0l47.27-30.65a7.93,7.93,0,0,0,3.59-6.73l-.39-62.09a7.93,7.93,0,0,0-4.72-7.24L367.34,59.08Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M367.34,59.08l.8,126.83,47.21-30.59a7.93,7.93,0,0,0,3.66-6.7l-.37-62.34A7.73,7.73,0,0,0,414,79.21Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M381.16,130.3l-28.8.18-5.87,13.92-8,0,24.2-55.67,7.66,0,25,55.36-8.13.06ZM378.41,124,366.55,96.84,355,124.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-71"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 344.86,
    y: 156.27,
    width: 271.84,
    height: 158.4,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.12,306.7c-.14,0-.26-32.39-.26-72.34S366,162,366.12,162s.26,32.38.26,72.34S366.27,306.7,366.12,306.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,168.12a39.07,39.07,0,0,1-9,0,39.07,39.07,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,177.65a39.07,39.07,0,0,1-9,0,39.07,39.07,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,187.19a39.07,39.07,0,0,1-9,0,39.07,39.07,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,196.72a39.07,39.07,0,0,1-9,0,39.07,39.07,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,206.25a39.07,39.07,0,0,1-9,0,39.07,39.07,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,215.79a39.07,39.07,0,0,1-9,0,39.07,39.07,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,225.32a39.07,39.07,0,0,1-9,0,39.07,39.07,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,234.85a39.07,39.07,0,0,1-9,0,39.07,39.07,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,244.39a39.07,39.07,0,0,1-9,0,39.07,39.07,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,253.92a39.07,39.07,0,0,1-9,0,39.07,39.07,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,263.45a39.07,39.07,0,0,1-9,0,39.07,39.07,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,273a39.07,39.07,0,0,1-9,0,39.07,39.07,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,282.52a39.07,39.07,0,0,1-9,0,39.07,39.07,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,292.05a39.07,39.07,0,0,1-9,0,39.07,39.07,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,301.59a39.07,39.07,0,0,1-9,0,39.07,39.07,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.62,167.56c0,.14-5.23.26-11.68.26s-11.69-.12-11.69-.26,5.23-.26,11.69-.26S396.62,167.41,396.62,167.56Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.62,301.59c0,.14-5.23.26-11.68.26s-11.69-.12-11.69-.26,5.23-.26,11.69-.26S396.62,301.44,396.62,301.59Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.16,187.19c0,.14-9.79.26-21.86.26s-21.86-.12-21.86-.26,9.79-.26,21.86-.26S429.16,187,429.16,187.19Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.7,187.19c0,.14-9.78.26-21.85.26s-21.86-.12-21.86-.26,9.78-.26,21.86-.26S479.7,187,479.7,187.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.39,196.72c0,.14-14.43.26-32.21.26s-32.22-.12-32.22-.26,14.42-.26,32.22-.26S460.39,196.58,460.39,196.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.39,206.25c0,.15-14.43.26-32.21.26S396,206.4,396,206.25s14.42-.26,32.22-.26S460.39,206.11,460.39,206.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.73,234.85c0,.15-14.42.26-32.21.26s-32.21-.11-32.21-.26,14.42-.26,32.21-.26S504.73,234.71,504.73,234.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.6,215.79c0,.14-14.43.26-32.21.26s-32.22-.12-32.22-.26,14.42-.26,32.22-.26S485.6,215.64,485.6,215.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.32,215.79c0,.14-14.42.26-32.21.26s-32.21-.12-32.21-.26,14.42-.26,32.21-.26S564.32,215.64,564.32,215.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.94,196.72c0,.14-14.42.26-32.21.26s-32.21-.12-32.21-.26,14.42-.26,32.21-.26S536.94,196.58,536.94,196.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.45,234.85c0,.15-14.43.26-32.21.26S517,235,517,234.85s14.42-.26,32.22-.26S581.45,234.71,581.45,234.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.56,206.25c0,.15-22.4.26-50,.26s-50-.11-50-.26,22.39-.26,50-.26S572.56,206.11,572.56,206.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.62,177.65c0,.15-5.23.26-11.68.26s-11.69-.11-11.69-.26,5.23-.26,11.69-.26S396.62,177.51,396.62,177.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.62,292.05c0,.15-5.23.26-11.68.26s-11.69-.11-11.69-.26,5.23-.26,11.69-.26S396.62,291.91,396.62,292.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.19,215.79c0,.14-5.23.26-11.68.26s-11.68-.12-11.68-.26,5.23-.26,11.68-.26S408.19,215.64,408.19,215.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.45,215.79c0,.14-5.23.26-11.68.26s-11.68-.12-11.68-.26,5.23-.26,11.68-.26S595.45,215.64,595.45,215.79Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.16,253.86c0,.15-9.79.26-21.86.26s-21.86-.11-21.86-.26,9.79-.26,21.86-.26S429.16,253.72,429.16,253.86Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.7,253.86c0,.15-9.78.26-21.85.26S436,254,436,253.86s9.78-.26,21.86-.26S479.7,253.72,479.7,253.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.39,263.4c0,.14-14.43.26-32.21.26S396,263.54,396,263.4s14.42-.26,32.22-.26S460.39,263.25,460.39,263.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.39,272.93c0,.14-14.43.26-32.21.26s-32.22-.12-32.22-.26,14.42-.26,32.22-.26S460.39,272.79,460.39,272.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.6,282.46c0,.15-14.43.26-32.21.26s-32.22-.11-32.22-.26,14.42-.26,32.22-.26S485.6,282.32,485.6,282.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.32,282.46c0,.15-14.42.26-32.21.26s-32.21-.11-32.21-.26,14.42-.26,32.21-.26S564.32,282.32,564.32,282.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.94,263.4c0,.14-14.42.26-32.21.26s-32.21-.12-32.21-.26,14.42-.26,32.21-.26S536.94,263.25,536.94,263.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.56,272.93c0,.14-22.4.26-50,.26s-50-.12-50-.26,22.39-.26,50-.26S572.56,272.79,572.56,272.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.19,282.46c0,.15-5.23.26-11.68.26s-11.68-.11-11.68-.26,5.23-.26,11.68-.26S408.19,282.32,408.19,282.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.45,282.46c0,.15-5.23.26-11.68.26s-11.68-.11-11.68-.26,5.23-.26,11.68-.26S595.45,282.32,595.45,282.46Z",
    style: {
      fill: "#052465"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--React--inject-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M652.65,312.48c-.19.11-1.88-2.7-5.29-7.52-1.7-2.41-3.85-5.31-6.52-8.53a95,95,0,0,0-9.79-10.21,54.26,54.26,0,0,0-6.46-5,24.43,24.43,0,0,0-7.83-3.52,9.55,9.55,0,0,0-4.22-.06,6.29,6.29,0,0,0-3.44,2.21,10.17,10.17,0,0,0-1.89,4.08,22.08,22.08,0,0,0-.6,4.87,48.11,48.11,0,0,0,1.14,10.39,84.39,84.39,0,0,0,3,10.62A133,133,0,0,0,634,350.06a86.31,86.31,0,0,0,7.68,7.93,48.2,48.2,0,0,0,8.43,6.19,23,23,0,0,0,4.52,1.92,10.37,10.37,0,0,0,4.48.4,6.25,6.25,0,0,0,3.63-1.89,9.42,9.42,0,0,0,2.06-3.67,24.32,24.32,0,0,0,.86-8.54,52.82,52.82,0,0,0-1.07-8.09,93.8,93.8,0,0,0-4-13.58c-1.45-3.92-2.89-7.23-4.12-9.91-2.47-5.37-4.06-8.23-3.87-8.34a9.3,9.3,0,0,1,1.4,1.94c.82,1.33,2,3.32,3.38,5.95s3,5.91,4.57,9.83a89.73,89.73,0,0,1,4.39,13.73,54.48,54.48,0,0,1,1.28,8.35,26.34,26.34,0,0,1-.81,9.31,11.7,11.7,0,0,1-2.5,4.55,8.43,8.43,0,0,1-4.87,2.61,12.52,12.52,0,0,1-5.49-.39,24.58,24.58,0,0,1-5-2.08,49.43,49.43,0,0,1-8.94-6.43,86.26,86.26,0,0,1-8-8.13,131.91,131.91,0,0,1-23.7-41,85.29,85.29,0,0,1-3-11,49.77,49.77,0,0,1-1.11-11,24.45,24.45,0,0,1,.72-5.39,12.64,12.64,0,0,1,2.4-5,8.54,8.54,0,0,1,4.7-2.91,11.65,11.65,0,0,1,5.2.11,26.38,26.38,0,0,1,8.46,3.95,56.1,56.1,0,0,1,6.6,5.28A90.55,90.55,0,0,1,642,295.52c2.6,3.35,4.64,6.36,6.23,8.87s2.73,4.53,3.46,5.91A9.09,9.09,0,0,1,652.65,312.48Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.77,312.42c.18.11-1.44,2.84-4,8-1.26,2.56-2.74,5.73-4.23,9.49a86.1,86.1,0,0,0-4.07,13.06,49.16,49.16,0,0,0-1.12,7.8,23,23,0,0,0,.8,8.24,9.49,9.49,0,0,0,2,3.57,6.56,6.56,0,0,0,3.48,1.94,10,10,0,0,0,4.35-.12,20.23,20.23,0,0,0,4.46-1.6,43.78,43.78,0,0,0,8.43-5.55,79.38,79.38,0,0,0,7.74-7.34,122.52,122.52,0,0,0,23.63-38.18,78.38,78.38,0,0,0,3.11-10.21,43.81,43.81,0,0,0,1.21-10,20.51,20.51,0,0,0-.56-4.7,10.06,10.06,0,0,0-1.83-3.95,6.57,6.57,0,0,0-3.3-2.25,9.48,9.48,0,0,0-4.08-.18,23.09,23.09,0,0,0-7.73,2.95,50.75,50.75,0,0,0-6.48,4.49,87.15,87.15,0,0,0-9.87,9.47c-2.7,3-4.88,5.75-6.61,8-3.46,4.54-5.18,7.21-5.36,7.1a7.6,7.6,0,0,1,1-2.09c.75-1.31,1.9-3.23,3.53-5.6a105,105,0,0,1,6.33-8.38,82.53,82.53,0,0,1,9.8-9.94,49.51,49.51,0,0,1,6.63-4.8,25,25,0,0,1,8.42-3.36,11.77,11.77,0,0,1,5,.18,8.82,8.82,0,0,1,4.46,2.95,12.47,12.47,0,0,1,2.33,4.8,23.24,23.24,0,0,1,.68,5.24A45.66,45.66,0,0,1,668.81,302a80,80,0,0,1-3.15,10.56,122.35,122.35,0,0,1-24.15,39,80.2,80.2,0,0,1-8,7.54,45.84,45.84,0,0,1-9,5.78,22.86,22.86,0,0,1-5,1.73,12.28,12.28,0,0,1-5.33.06,8.82,8.82,0,0,1-4.63-2.67,11.73,11.73,0,0,1-2.41-4.42,25,25,0,0,1-.75-9,49.54,49.54,0,0,1,1.34-8.08,82.47,82.47,0,0,1,4.52-13.21,104.14,104.14,0,0,1,4.67-9.4c1.4-2.52,2.6-4.4,3.44-5.66S621.69,312.37,621.77,312.42Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.24,300.91c0,.22-3.18.27-8.87.82-2.84.28-6.31.7-10.29,1.4a87.75,87.75,0,0,0-13.25,3.42,50.07,50.07,0,0,0-7.22,3.15,22.89,22.89,0,0,0-6.59,5,9.53,9.53,0,0,0-2,3.56,6.65,6.65,0,0,0,.18,4,10.22,10.22,0,0,0,2.39,3.64,20.88,20.88,0,0,0,3.71,2.94,43.83,43.83,0,0,0,9.15,4.25,78.16,78.16,0,0,0,10.33,2.72,122.14,122.14,0,0,0,44.89,0A78,78,0,0,0,668,333.1a43.68,43.68,0,0,0,9.16-4.25,20.88,20.88,0,0,0,3.71-2.94,10.22,10.22,0,0,0,2.39-3.64,6.65,6.65,0,0,0,.18-4,9.53,9.53,0,0,0-2-3.56,22.89,22.89,0,0,0-6.59-5,48,48,0,0,0-7.22-3.15,87.75,87.75,0,0,0-13.25-3.42c-4-.7-7.45-1.12-10.29-1.4-5.69-.55-8.87-.6-8.86-.82a7.76,7.76,0,0,1,2.3-.24c1.51-.05,3.75-.08,6.63.05s6.39.4,10.45,1a82.6,82.6,0,0,1,13.61,3.1,50.72,50.72,0,0,1,7.57,3.12,24.86,24.86,0,0,1,7.29,5.39,11.7,11.7,0,0,1,2.49,4.37,8.86,8.86,0,0,1-.16,5.34,12.36,12.36,0,0,1-2.86,4.51,22.22,22.22,0,0,1-4.1,3.33,45.69,45.69,0,0,1-9.64,4.59,79.18,79.18,0,0,1-10.64,2.87,121.84,121.84,0,0,1-45.89,0,79.18,79.18,0,0,1-10.64-2.87,45.69,45.69,0,0,1-9.64-4.59,22.55,22.55,0,0,1-4.1-3.33,12.28,12.28,0,0,1-2.86-4.51,8.86,8.86,0,0,1-.16-5.34,11.77,11.77,0,0,1,2.49-4.37,24.91,24.91,0,0,1,7.29-5.39,49.19,49.19,0,0,1,7.57-3.11,81.48,81.48,0,0,1,13.61-3.11c4.06-.58,7.58-.85,10.45-1s5.12-.1,6.63-.05A7.87,7.87,0,0,1,635.24,300.91Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 637.71,
    cy: 322.29,
    r: 8.37,
    transform: "translate(217.19 899.96) rotate(-80.76)",
    style: {
      fill: "#052465"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.13,235.47H499.58a6.74,6.74,0,0,1,6.74,6.74v185a14.57,14.57,0,0,1-14.57,14.57H208.95a14.57,14.57,0,0,1-14.57-14.57v-184A7.75,7.75,0,0,1,202.13,235.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.34,426.5h338a0,0,0,0,1,0,0v4.33a13.72,13.72,0,0,1-13.72,13.72H195.06a13.72,13.72,0,0,1-13.72-13.72V426.5a0,0,0,0,1,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.75,
    y: 243.67,
    width: 294.32,
    height: 174.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.6 426.5 323.79 433.17 382.8 433.17 386.7 426.5 319.6 426.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.43,
    y: 426.43,
    width: 311.94,
    height: 0.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.49,
    y: 253.76,
    width: 277.56,
    height: 164.11,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.78,413.05c-.14,0-.26-34.95-.26-78.06s.12-78.06.26-78.06S233,291.87,233,335,232.92,413.05,232.78,413.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,271.08a19.36,19.36,0,0,1-4.51.26,19.36,19.36,0,0,1-4.51-.26,39.25,39.25,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.53,262.22a19.36,19.36,0,0,1-4.51.26,19.36,19.36,0,0,1-4.51-.26,39.25,39.25,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,280.63a39.25,39.25,0,0,1-9,0,39.25,39.25,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,290.18a39.25,39.25,0,0,1-9,0,19.36,19.36,0,0,1,4.51-.26A19.36,19.36,0,0,1,227.18,290.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,299.73a39.25,39.25,0,0,1-9,0,19.36,19.36,0,0,1,4.51-.26A19.36,19.36,0,0,1,227.18,299.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,309.28a39.25,39.25,0,0,1-9,0,19.36,19.36,0,0,1,4.51-.26A19.36,19.36,0,0,1,227.18,309.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,318.82a19,19,0,0,1-4.51.27,19,19,0,0,1-4.51-.27,39.25,39.25,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,328.37a19.36,19.36,0,0,1-4.51.26,19.36,19.36,0,0,1-4.51-.26,39.25,39.25,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,337.92a19.36,19.36,0,0,1-4.51.26,19.36,19.36,0,0,1-4.51-.26,39.25,39.25,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,347.47a19.36,19.36,0,0,1-4.51.26,19.36,19.36,0,0,1-4.51-.26,39.25,39.25,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,357a39.25,39.25,0,0,1-9,0,39.25,39.25,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,366.57a39.25,39.25,0,0,1-9,0,19.36,19.36,0,0,1,4.51-.26A19.36,19.36,0,0,1,227.18,366.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,376.12a39.25,39.25,0,0,1-9,0,19.36,19.36,0,0,1,4.51-.26A19.36,19.36,0,0,1,227.18,376.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,385.67a39.25,39.25,0,0,1-9,0,19.36,19.36,0,0,1,4.51-.26A19.36,19.36,0,0,1,227.18,385.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,395.22a39.25,39.25,0,0,1-9,0,19,19,0,0,1,4.51-.27A19,19,0,0,1,227.18,395.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,404.76a19.36,19.36,0,0,1-4.51.26,19.36,19.36,0,0,1-4.51-.26,39.25,39.25,0,0,1,9,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.33,270.52c0,.14-5.24.26-11.7.26s-11.71-.12-11.71-.26,5.24-.26,11.71-.26S263.33,270.37,263.33,270.52Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.33,404.76c0,.15-5.24.26-11.7.26s-11.71-.11-11.71-.26,5.24-.26,11.71-.26S263.33,404.62,263.33,404.76Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.92,290.18c0,.14-9.81.26-21.9.26s-21.89-.12-21.89-.26,9.8-.26,21.89-.26S295.92,290,295.92,290.18Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.55,290.18c0,.14-9.81.26-21.9.26s-21.89-.12-21.89-.26,9.8-.26,21.89-.26S346.55,290,346.55,290.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.2,299.73c0,.14-14.45.26-32.27.26s-32.26-.12-32.26-.26,14.44-.26,32.26-.26S327.2,299.58,327.2,299.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.2,309.28c0,.14-14.45.26-32.27.26s-32.26-.12-32.26-.26,14.44-.26,32.26-.26S327.2,309.13,327.2,309.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.61,337.92c0,.15-14.44.26-32.26.26s-32.27-.11-32.27-.26,14.45-.26,32.27-.26S371.61,337.78,371.61,337.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.45,318.82c0,.15-14.45.27-32.27.27s-32.26-.12-32.26-.27,14.44-.26,32.26-.26S352.45,318.68,352.45,318.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.3,318.82c0,.15-14.45.27-32.26.27s-32.27-.12-32.27-.27,14.45-.26,32.27-.26S431.3,318.68,431.3,318.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.88,299.73c0,.14-14.45.26-32.27.26s-32.26-.12-32.26-.26,14.44-.26,32.26-.26S403.88,299.58,403.88,299.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.45,337.92c0,.15-14.45.26-32.26.26s-32.27-.11-32.27-.26,14.45-.26,32.27-.26S448.45,337.78,448.45,337.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.55,309.28c0,.14-22.43.26-50.1.26s-50.1-.12-50.1-.26,22.43-.26,50.1-.26S439.55,309.13,439.55,309.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.33,280.63c0,.14-5.24.26-11.7.26s-11.71-.12-11.71-.26,5.24-.26,11.71-.26S263.33,280.49,263.33,280.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.33,395.22c0,.14-5.24.26-11.7.26s-11.71-.12-11.71-.26,5.24-.27,11.71-.27S263.33,395.07,263.33,395.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.92,318.82c0,.15-5.24.27-11.7.27s-11.7-.12-11.7-.27,5.23-.26,11.7-.26S274.92,318.68,274.92,318.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.48,318.82c0,.15-5.24.27-11.7.27s-11.7-.12-11.7-.27,5.23-.26,11.7-.26S462.48,318.68,462.48,318.82Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.92,357c0,.15-9.81.26-21.9.26s-21.89-.11-21.89-.26,9.8-.26,21.89-.26S295.92,356.82,295.92,357Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.55,357c0,.15-9.81.26-21.9.26s-21.89-.11-21.89-.26,9.8-.26,21.89-.26S346.55,356.82,346.55,357Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.2,366.51c0,.15-14.45.26-32.27.26s-32.26-.11-32.26-.26,14.44-.26,32.26-.26S327.2,366.37,327.2,366.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.2,376.06c0,.15-14.45.26-32.27.26s-32.26-.11-32.26-.26,14.44-.26,32.26-.26S327.2,375.92,327.2,376.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.45,385.61c0,.14-14.45.26-32.27.26s-32.26-.12-32.26-.26,14.44-.26,32.26-.26S352.45,385.47,352.45,385.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.3,385.61c0,.14-14.45.26-32.26.26s-32.27-.12-32.27-.26,14.45-.26,32.27-.26S431.3,385.47,431.3,385.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.88,366.51c0,.15-14.45.26-32.27.26s-32.26-.11-32.26-.26,14.44-.26,32.26-.26S403.88,366.37,403.88,366.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.55,376.06c0,.15-22.43.26-50.1.26s-50.1-.11-50.1-.26,22.43-.26,50.1-.26S439.55,375.92,439.55,376.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.92,385.61c0,.14-5.24.26-11.7.26s-11.7-.12-11.7-.26,5.23-.26,11.7-.26S274.92,385.47,274.92,385.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.48,385.61c0,.14-5.24.26-11.7.26s-11.7-.12-11.7-.26,5.23-.26,11.7-.26S462.48,385.47,462.48,385.61Z",
    style: {
      fill: "#052465"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M700.42,444.56c0,.14-145.71.26-325.4.26s-325.44-.12-325.44-.26,145.68-.26,325.44-.26S700.42,444.41,700.42,444.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568.68,388.12l4,12.49a14.43,14.43,0,0,0,11.2,10l26.66,5,7.25-.23-7.25-9-20-6.83a5.37,5.37,0,0,1-4-3.84l-8-17.36-10.11,6.2Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.58,304.23a8.79,8.79,0,0,0-1.5-5.54,6.77,6.77,0,0,0-4.38-3.38,5,5,0,0,0-5.19,3.06,6.52,6.52,0,0,0,.8,6.16,8.23,8.23,0,0,0,2.43,2.27,15.26,15.26,0,0,0-6,7.65c-.37,1.06-.62,2.16-1.08,3.18a4.74,4.74,0,0,1-2.21,2.45c-.76.34-1.61.37-2.39.66a4.38,4.38,0,0,0-2.63,3,5.32,5.32,0,0,0,.71,4,4.13,4.13,0,0,1,.9,1.86,4.79,4.79,0,0,1-.29,1.39,3.8,3.8,0,0,0,6.24,3.71,5.41,5.41,0,0,0,2.3,2.89c1.14.54,2.82.05,3-1.19a3,3,0,0,0,5.71-1.08l21.5-23.51C564.3,303.27,551.75,304,549.58,304.23Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.94,312.4a2.7,2.7,0,0,0-2.4,2.72h0l1.52,36.2c.06,4.28,7.82,9.34,12.39,9.24h0c4.63-.1,3.27-5,3.33-9.07.12-6.8.11-9.35.12-9.31s5.84-1,7.05-8.59c.6-3.79.41-10,.09-15.08-.29-4.57-3.32-10.18-7.87-9.7Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.06,323.44a1,1,0,0,1-.94,1,.94.94,0,0,1-1-.88,1,1,0,0,1,.94-1A.94.94,0,0,1,566.06,323.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.69,321.74c-.12.13-.86-.42-1.91-.42s-1.83.53-1.94.4.07-.28.4-.53a2.74,2.74,0,0,1,1.55-.48,2.62,2.62,0,0,1,1.53.5C566.64,321.45,566.75,321.68,566.69,321.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.78,323.44a1,1,0,0,1-.94,1,.94.94,0,0,1-1-.88,1,1,0,0,1,.94-1A.94.94,0,0,1,555.78,323.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.35,321.94c-.12.12-.86-.42-1.91-.42s-1.82.53-1.94.4.07-.29.41-.53a2.64,2.64,0,0,1,1.55-.48,2.61,2.61,0,0,1,1.52.49C556.3,321.65,556.41,321.88,556.35,321.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.17,329.74a6.54,6.54,0,0,1,1.71-.31c.27,0,.52-.08.57-.27a1.38,1.38,0,0,0-.18-.79c-.26-.65-.52-1.33-.8-2.05a34.6,34.6,0,0,1-1.78-5.35,35.16,35.16,0,0,1,2.21,5.2c.26.72.52,1.4.76,2.05a1.57,1.57,0,0,1,.14,1.06.68.68,0,0,1-.44.39,1.66,1.66,0,0,1-.46.06A6.94,6.94,0,0,1,560.17,329.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.9,342.18a19.42,19.42,0,0,1-10.21-2.72s2.48,5.23,10.1,4.52Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.72,332.27a1.88,1.88,0,0,0-1.69-.7,1.75,1.75,0,0,0-1.2.64,1.09,1.09,0,0,0-.08,1.25,1.27,1.27,0,0,0,1.38.35,3.92,3.92,0,0,0,1.34-.8,1.26,1.26,0,0,0,.3-.31.35.35,0,0,0,0-.39",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.07,330.46c.18,0,.18,1.14,1.15,2s2.2.68,2.21.84-.28.22-.79.24a2.93,2.93,0,0,1-1.84-.64,2.51,2.51,0,0,1-.89-1.63C556.87,330.74,557,330.46,557.07,330.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.83,320.1c-.11.28-1.16.15-2.39.3s-2.23.48-2.4.22.1-.39.51-.66a4,4,0,0,1,1.77-.63,4.06,4.06,0,0,1,1.87.22C556.64,319.74,556.87,320,556.83,320.1Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.3,318.7c-.18.24-.91,0-1.78,0s-1.61.16-1.78-.09,0-.36.37-.59a2.5,2.5,0,0,1,1.45-.39,2.47,2.47,0,0,1,1.42.48C566.28,318.34,566.39,318.58,566.3,318.7Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.39,324.59a1.93,1.93,0,0,0-2,.1,3.53,3.53,0,0,0,2.23,6.56",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.37,306.27a15.48,15.48,0,0,1,7.32,2.27,10.63,10.63,0,0,1,5.23,6.21,2.18,2.18,0,0,1-.06,1.72,1.69,1.69,0,0,1-2.09.45,4.9,4.9,0,0,1-1.7-1.57,3.26,3.26,0,0,1-6.33-.07,2.86,2.86,0,0,1-2.94,2.62,3.75,3.75,0,0,1-3.24-2.56,9.61,9.61,0,0,1-1.34,3.72,3.26,3.26,0,0,1-3.45,1.41,6.78,6.78,0,0,1,0,3.41,2.33,2.33,0,0,1-2.69,1.57c-1.06-.36-1.47-1.61-1.71-2.7a25.17,25.17,0,0,1-.82-6.39,9.35,9.35,0,0,1,7.55-9.48,25,25,0,0,1,6.63-.61",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.86,329c0-.05-.3.07-.67-.1a1.33,1.33,0,0,1-.65-1.3,1.35,1.35,0,0,1,.81-1.23,4.38,4.38,0,0,1,.68-.13s-.26-.24-.76-.13a1.36,1.36,0,0,0-.75.46,1.71,1.71,0,0,0-.38,1,1.52,1.52,0,0,0,1,1.58C543.61,329.28,543.9,329,543.86,329Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541,329.38s-.11,0-.32.08a6.49,6.49,0,0,0-3.33,2.73,4.89,4.89,0,0,0-.68,2.29,5.37,5.37,0,0,0,.64,2.68,6.29,6.29,0,0,0,2,2.26,5.64,5.64,0,0,0,3.11,1,5.91,5.91,0,0,0,5.15-3.22,5,5,0,0,0,.54-2.7,5.63,5.63,0,0,0-.74-2.27,5.44,5.44,0,0,0-2.52-2.3,3.63,3.63,0,0,0-.89-.27q-.32-.06-.33,0s.44.1,1.15.44a5.54,5.54,0,0,1,2.35,2.29,5.46,5.46,0,0,1,.65,2.17,4.77,4.77,0,0,1-.54,2.51,5.56,5.56,0,0,1-4.82,3,5.68,5.68,0,0,1-4.81-3,4.76,4.76,0,0,1,0-4.66,6.54,6.54,0,0,1,2.32-2.35C540.55,329.56,541,329.41,541,329.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.25,305.76c-.08,0-.24-.67-.71-1.66a9.15,9.15,0,0,0-6.47-5.1c-1.08-.23-1.78-.22-1.78-.31a3.8,3.8,0,0,1,1.84-.06,8.51,8.51,0,0,1,4.1,1.74,8.41,8.41,0,0,1,2.64,3.58A3.8,3.8,0,0,1,547.25,305.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.73,334.71s-.13,0-.27-.25a1.46,1.46,0,0,1-.18-1,2.17,2.17,0,0,1,.94-1.38,18.23,18.23,0,0,1,1.89-1,2.31,2.31,0,0,0,1.32-1.88,11.06,11.06,0,0,0-.52-2.87,5.72,5.72,0,0,1-.16-1.68,2.8,2.8,0,0,1,.72-1.66,6.89,6.89,0,0,1,3.21-1.69,5.34,5.34,0,0,0,2.88-1.66,4.31,4.31,0,0,0,.48-3,15.67,15.67,0,0,1-.21-3,8.32,8.32,0,0,1,2.89-5.64,5.13,5.13,0,0,1,.85-.59,1.16,1.16,0,0,1,.33-.16s-.4.3-1,.9a8.4,8.4,0,0,0-2.05,3.05,8.13,8.13,0,0,0-.55,2.47,16.26,16.26,0,0,0,.25,2.93,4.72,4.72,0,0,1-.53,3.36,5.72,5.72,0,0,1-3.14,1.86,6.51,6.51,0,0,0-3,1.54,3.09,3.09,0,0,0-.47,2.9,10.8,10.8,0,0,1,.48,3,2.6,2.6,0,0,1-.54,1.36,3.13,3.13,0,0,1-1,.81c-.72.39-1.4.61-1.9,1a2,2,0,0,0-.91,1.19A1.49,1.49,0,0,0,529.73,334.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.89,315c-.08,0-.15-.81-.55-2a10.66,10.66,0,0,0-2.58-4.23,10.83,10.83,0,0,0-4.23-2.56c-1.22-.4-2-.46-2-.55a4.73,4.73,0,0,1,2.13.2,9.74,9.74,0,0,1,7.06,7A4.55,4.55,0,0,1,556.89,315Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563,311.7a19,19,0,0,0-1.33-2.36,10.43,10.43,0,0,0-5.22-3.63,16.15,16.15,0,0,0-6.45-.52c-1.67.18-2.69.41-2.71.33a8.9,8.9,0,0,1,2.66-.69,14.73,14.73,0,0,1,6.66.38,10.1,10.1,0,0,1,5.36,3.92,6.77,6.77,0,0,1,.89,1.83A1.79,1.79,0,0,1,563,311.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.74,303.85s-.19.5-.78,1.11a7.51,7.51,0,0,1-2.78,1.74,7.36,7.36,0,0,1-3.25.41,2.59,2.59,0,0,1-1.31-.37,13.15,13.15,0,0,0,4.39-.53A13.4,13.4,0,0,0,549.74,303.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.09,444.62c-18.31-6.06-5.76-30.28-5.76-30.28l80,7.53A11.57,11.57,0,0,1,641,433.45h0A11.57,11.57,0,0,1,629.44,445l-74.35-.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.35,444.6c-17.84-6-5.54-30.27-5.54-30.27l78,7.36c7.62.1,11.34,3.78,11.34,11.55h0c0,6.39-2.38,11.78-11.31,11.6l-72.5-.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.46,418.43h.22l.65,0,2.5.1L567,419l30.27,1.66c1.48.07,2.94.2,4.38.22s2.87.08,4.26.17,2.77.19,4.11.33a14.94,14.94,0,0,1,3.9.8,9.63,9.63,0,0,1,3.25,2.08,8.59,8.59,0,0,1,2,3.16,15.47,15.47,0,0,1,.81,3.41,24.19,24.19,0,0,1,.21,3.23,13.76,13.76,0,0,1-1,5.43,9,9,0,0,1-2.43,3.31,6.6,6.6,0,0,1-2.21,1.24c-.55.18-.56.12,0-.08a6.84,6.84,0,0,0,2.14-1.29,9.06,9.06,0,0,0,2.32-3.28,13.65,13.65,0,0,0,1-5.33,23.63,23.63,0,0,0-.24-3.18,15.51,15.51,0,0,0-.8-3.33,8.33,8.33,0,0,0-1.91-3,8.84,8.84,0,0,0-3.13-2,14.24,14.24,0,0,0-3.81-.77c-1.33-.14-2.7-.24-4.09-.32s-2.81-.14-4.24-.16-2.91-.15-4.39-.22L567,419.29l-9.18-.59-2.49-.18-.65-.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.2,420l-6.41-3.15L571.32,402l-.43-19,9.06-3.82-7.19-18.05c-1.31-2.67-4-9.74-10.76-12.06a8.15,8.15,0,0,1,.24-3c.53-.89-16.59-1.42-17.56-1.07s.16,3.48.05,4c-6.09,1.68-12,4.19-14.23,12.56-.86,3.26-.57,10.14-.1,13.46l4.75,25.13-2.67,8.25s-9.35,19.48-5.8,27.09,9.57,9.33,9.57,9.33l46.58-.1Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M535.46,390.2a93.9,93.9,0,0,0,3.42,11.89,25.67,25.67,0,0,0,3.74,6.86,17.35,17.35,0,0,0,9,5.47,28.27,28.27,0,0,0,10.61.52l-17.63-10-4.69-16.29Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M571.31,401.45a7.45,7.45,0,0,1-.13-1.35c0-.94-.1-2.18-.18-3.67-.13-3.1-.28-7.39-.43-12.13s-.25-9-.3-12.13c0-1.5,0-2.74,0-3.68a8.38,8.38,0,0,1,0-1.35,8,8,0,0,1,.12,1.34c.05.94.11,2.18.18,3.68.13,3.1.29,7.39.43,12.13s.25,9,.31,12.13c0,1.5,0,2.74,0,3.68A8.38,8.38,0,0,1,571.31,401.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.06,383.7a1.57,1.57,0,0,1-.32.14l-1,.36-3.84,1.35-14.06,4.85-.23.08-.05-.24c-.95-5.11-2.07-11.09-3.28-17.56h0v0c-.19-3.19-.83-6.52-.56-10a9.08,9.08,0,0,1,.69-2.45,11.07,11.07,0,0,1,1.16-2.21,9.38,9.38,0,0,1,3.7-3.16,8.1,8.1,0,0,1,8.78.95,11,11,0,0,1,2.35,3.58,33.62,33.62,0,0,1,1.37,3.76c.74,2.46,1.31,4.79,1.86,6.93l2.55,10c.29,1.15.51,2.05.67,2.71.07.28.12.51.17.69s0,.24,0,.23a1.12,1.12,0,0,1-.09-.25q-.09-.29-.21-.72c-.19-.66-.44-1.57-.77-2.72-.65-2.39-1.58-5.78-2.72-9.94-.58-2.08-1.15-4.4-1.91-6.84a33.39,33.39,0,0,0-1.38-3.7,10.47,10.47,0,0,0-2.24-3.41,7.64,7.64,0,0,0-8.24-.85,8.86,8.86,0,0,0-3.5,3,10.88,10.88,0,0,0-1.11,2.11,8.73,8.73,0,0,0-.65,2.32c-.26,3.37.35,6.7.55,9.93v0c1.18,6.47,2.27,12.45,3.2,17.57l-.28-.16,14-4.61,3.93-1.26,1-.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540,388.35c-.13,0-.5-.73-.83-1.73s-.47-1.85-.33-1.89.51.73.83,1.73S540.17,388.31,540,388.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.62,387.06c-.14,0-.45-.72-.68-1.69s-.32-1.77-.18-1.81.45.72.68,1.69S544.76,387,544.62,387.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.25,385.4c-.14,0-.45-.58-.69-1.38s-.32-1.48-.18-1.53.44.58.68,1.38S549.38,385.36,549.25,385.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.29,381.57c-.12.07-.65-.59-1-1.56s-.41-1.81-.28-1.83.42.73.77,1.65S574.42,381.49,574.29,381.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.77,379.59c-.13.07-.55-.51-.94-1.28s-.6-1.45-.47-1.52.55.51.94,1.28S577.9,379.53,577.77,379.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.37,349.79s.08.17.09.45h-.27a17.22,17.22,0,0,1-.32-2.38,8.11,8.11,0,0,1,0-2.85,7.71,7.71,0,0,1,.5,2.81,17.81,17.81,0,0,1,.07,2.4h-.27C547.26,349.94,547.32,349.78,547.37,349.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.53,349.79a5.69,5.69,0,0,1-.43-2.32,5.24,5.24,0,0,1,.09-2.35,5.69,5.69,0,0,1,.43,2.32A5.24,5.24,0,0,1,551.53,349.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.89,350.73a7.57,7.57,0,0,1-.3-2.8,7.94,7.94,0,0,1,.22-2.81,7.57,7.57,0,0,1,.3,2.8A7.94,7.94,0,0,1,555.89,350.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.45,350.14a5.79,5.79,0,0,1-.26-2.39,5.86,5.86,0,0,1,.26-2.4,5.57,5.57,0,0,1,.27,2.4A5.51,5.51,0,0,1,559.45,350.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.5,420.54c0,.14-8.69-.33-19.39-1.06s-19.36-1.44-19.35-1.58,8.69.33,19.39,1.06S582.51,420.4,582.5,420.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.53,389.54l4.29,14A14.5,14.5,0,0,0,553,413.68l26.66,5.07,7.25-.24-2.46-6.19-24.83-9.82a5.41,5.41,0,0,1-4-3.89l-3.75-14.05Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "561.1 418.93 561.33 417.2 581.81 416.4 591.86 391.05 630.15 393.65 617.23 421.79 561.1 418.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.93,407.49a2,2,0,1,1-.62-2.76A2,2,0,0,1,606.93,407.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283,236.89c16.69-6.06,8.12-31.23,8.12-31.23l-84.7,7.76a11.94,11.94,0,0,0-12,11.94h0a11.94,11.94,0,0,0,11.94,11.94l76.66-.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.93,306.59l-.17-8.4,16.11-5.73.67,11.7-.91.44c-4,1.91-20.7,9.43-23.81,9.72C162.35,314.63,173.93,306.59,173.93,306.59Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.36,310.74s-3.94,3.1-3.08,3.61,18-6.46,25.26-10.19l-.16-.33-19.9,8.3S169.25,310.42,168.36,310.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.61,303.73l-.25.13-.72.35L187,305.43c-2.27,1-5.42,2.39-8.93,3.82s-6.73,2.67-9.06,3.52l-2.77,1-.76.26-.27.07.26-.11.74-.29,2.75-1.06c2.32-.89,5.52-2.13,9-3.57s6.67-2.78,9-3.76l2.7-1.17.73-.31A1.12,1.12,0,0,1,190.61,303.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.58,312.36a7.76,7.76,0,0,0-1-1.09,6.87,6.87,0,0,0-1.36-.67,2.65,2.65,0,0,1,2.4,1.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.09,308.32s-.35-.13-.71-.38-.63-.5-.59-.55.34.13.7.39S174.12,308.27,174.09,308.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,307.18c0,.05-.32,0-.67-.14s-.63-.27-.61-.32.32,0,.67.14S175.06,307.13,175,307.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.23,305.45c0,.05-.31.24-.74.42a2,2,0,0,1-.82.24c0-.05.31-.24.74-.42A2,2,0,0,1,175.23,305.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.09,304.35a1.73,1.73,0,0,1-.77.61,1.58,1.58,0,0,1-.95.24,5.74,5.74,0,0,1,.86-.42A5.3,5.3,0,0,1,175.09,304.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,307.22a3,3,0,0,1-1,.38,5.42,5.42,0,0,1-1.12.19,3.09,3.09,0,0,1-.68,0,.55.55,0,0,1-.37-.2.45.45,0,0,1,0-.45,1.92,1.92,0,0,1,2.4-.37,1.9,1.9,0,0,1,.58.52c.1.15.14.24.13.25a2.75,2.75,0,0,0-.78-.65,1.87,1.87,0,0,0-1-.2,1.61,1.61,0,0,0-1.11.55c-.11.18,0,.33.23.36a2.73,2.73,0,0,0,.64,0,7.81,7.81,0,0,0,1.1-.14C172.66,307.34,173,307.19,173,307.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.81,307.37a1.09,1.09,0,0,1-.38-.63,1.67,1.67,0,0,1,0-.81,1,1,0,0,1,.6-.82.42.42,0,0,1,.48.33,1.21,1.21,0,0,1,0,.5,3.44,3.44,0,0,1-.22.76,1.53,1.53,0,0,1-.39.62s.12-.25.26-.67a3.24,3.24,0,0,0,.17-.74c.05-.26,0-.66-.27-.6s-.4.41-.47.66a1.69,1.69,0,0,0,0,.74A4,4,0,0,0,172.81,307.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.63,299.75s-.44.13-1.09.49a5.07,5.07,0,0,0-2.65,4.73c0,.73.18,1.18.15,1.19a1.35,1.35,0,0,1-.13-.31,4.26,4.26,0,0,1-.16-.87,4.9,4.9,0,0,1,2.73-4.86,3.78,3.78,0,0,1,.83-.32A1,1,0,0,1,188.63,299.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.54,294.14a28.4,28.4,0,0,1,1.38,3,26.52,26.52,0,0,1,1.2,3.1,27.63,27.63,0,0,1-1.38-3A29.46,29.46,0,0,1,184.54,294.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.57,305.56a9.84,9.84,0,0,1-2.1,1.11,9.43,9.43,0,0,1-2.27.71c0-.05,1-.39,2.19-.9S182.54,305.51,182.57,305.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.51,304.36c.05,0,0,.24,0,.5s0,.49,0,.51-.18-.21-.17-.52S185.46,304.33,185.51,304.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.05,302.53s0,.21-.07.43-.21.39-.26.37,0-.22.08-.44S186,302.51,186.05,302.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.38,301.25c0,.06-.19.14-.38.3s-.3.35-.35.33,0-.27.22-.47S187.38,301.2,187.38,301.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.39,300.5s0,.15-.13.25-.22.14-.25.1,0-.15.12-.25S188.35,300.46,188.39,300.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.59,212.28l-47.3.89A15.18,15.18,0,0,0,176.5,226.5l-9.38,76.23h25.69l7.84-65.84H238Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.44,297.88c0,.12,5.63.26,12.57.3s12.45-.13,12.57-.14c.8-.08-5.63-.26-12.57-.3S167.44,297.76,167.44,297.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.61,209.88h-.93L261,210l-9.78.46L219,212.12c-1.58.07-3.13.2-4.66.22s-3.06.09-4.55.17-2.94.19-4.37.34a16.06,16.06,0,0,0-4.16.81,10.07,10.07,0,0,0-3.45,2.09,8.65,8.65,0,0,0-2.1,3.19,15.3,15.3,0,0,0-.85,3.44,21.83,21.83,0,0,0-.23,3.26,13.12,13.12,0,0,0,1.1,5.48,8.91,8.91,0,0,0,2.58,3.34,7.2,7.2,0,0,0,2.35,1.26c.59.17.6.12,0-.08a7.56,7.56,0,0,1-2.28-1.31,9,9,0,0,1-2.47-3.3,13.09,13.09,0,0,1-1-5.39,22.67,22.67,0,0,1,.25-3.21,15.52,15.52,0,0,1,.86-3.36,8.35,8.35,0,0,1,2-3,9.81,9.81,0,0,1,3.34-2,16.6,16.6,0,0,1,4.06-.77c1.42-.14,2.88-.24,4.36-.32s3-.14,4.52-.16,3.09-.15,4.67-.22l32.25-1.8,9.78-.6,2.65-.18.69-.06A.75.75,0,0,0,264.61,209.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.54,178.26l-4.11,12.88a14.87,14.87,0,0,1-11.55,10.35L210,208.11l-1.86-4.42-1.74-6.53,20.66-7a5.53,5.53,0,0,0,4.17-4l8.23-17.9,10.42,6.39Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.56,138c-8.75,1-11.57,4.58-15.14,9.75a29.26,29.26,0,0,0-3.54,6.93l-6.63,18.78,13.83,4.27L247.62,193l-6.3,18.67,53.13,4.18-.15-27.13-.38-16.37c.5-6.2,1.79-19.34.69-22.46-4.73-13.33-15.16-10.77-22.81-12.67a51.52,51.52,0,0,0-10.54,0",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.45,187c0,.14-10.39.26-23.21.26S248,187.17,248,187s10.39-.26,23.21-.26S294.45,186.88,294.45,187Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.67,196.3c0,.15-10.39.26-23.21.26s-23.21-.11-23.21-.26,10.39-.26,23.21-.26S293.67,196.16,293.67,196.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.92,206.94c0,.15-11,.26-24.54.26s-24.55-.11-24.55-.26,11-.26,24.55-.26S293.92,206.8,293.92,206.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M287.47,181.1c-.69,3.59-1,7.47-2.22,10.92a26.44,26.44,0,0,1-3.55,7.23,17.88,17.88,0,0,1-9,6c-3.51,1.09-20.38,4.86-24,4.58l30.86-14.61,3.72-15.36Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M285.67,180.56l-3.39,13.06a15,15,0,0,1-11.1,11L243.94,211l-7.49.08V200.77l27.42-7.41a5.58,5.58,0,0,0,4-4.18l2.64-11.49Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.72,149.13c0,.14-11.45.26-25.58.26s-25.58-.12-25.58-.26,11.45-.26,25.58-.26S294.72,149,294.72,149.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,158c0,.15-12.34.26-27.57.26s-27.57-.11-27.57-.26,12.34-.26,27.57-.26S295,157.84,295,158Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.33,167.55c0,.15-13,.37-29,.49s-29,.11-29,0,13-.36,29-.49S294.32,167.41,294.33,167.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.92,177.69c0,.14-10.39.26-23.21.26s-23.21-.12-23.21-.26,10.39-.26,23.21-.26S293.92,177.55,293.92,177.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.34,181.65a.53.53,0,0,1,0-.22l.09-.63c.09-.59.22-1.4.37-2.42.33-2.12.81-5.19,1.34-9s1.14-8.47,1.45-13.69c.1-2.59.32-5.45-1-8a8.48,8.48,0,0,0-2.81-3.18,10,10,0,0,0-4.11-1.59h-.06a8.5,8.5,0,0,0-5.06.35,14.41,14.41,0,0,0-4.68,2.54,3.65,3.65,0,0,0-.72.81,10.18,10.18,0,0,0-.53,1,15.51,15.51,0,0,0-.77,2.1,41,41,0,0,0-.92,4.35c-.52,2.89-1,5.71-1.51,8.42-1,5.42-1.87,10.42-2.67,14.85l-.15-.23L284,180.34l4.23.94,1.11.26a1.89,1.89,0,0,1,.37.11l-.39-.05-1.11-.2-4.26-.83-15.44-3.12-.18,0,0-.2c.78-4.43,1.65-9.44,2.6-14.87.48-2.71,1-5.53,1.49-8.43a39.07,39.07,0,0,1,.93-4.39,14.59,14.59,0,0,1,.79-2.18,11.65,11.65,0,0,1,.56-1,4.46,4.46,0,0,1,.81-.92,15,15,0,0,1,4.87-2.65,9,9,0,0,1,5.38-.33h-.05a10.47,10.47,0,0,1,4.34,1.69,9,9,0,0,1,3,3.37,10.66,10.66,0,0,1,.78,2.05,12.79,12.79,0,0,1,.31,2.11l.06,1c0,.34,0,.68,0,1,0,.68-.05,1.34-.09,2-.34,5.25-1,9.87-1.56,13.72s-1.11,6.91-1.49,9c-.19,1-.35,1.82-.46,2.41l-.13.62A1.26,1.26,0,0,1,290.34,181.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.93,192.79a9.11,9.11,0,0,0,.07-1.39c0-1,0-2.25,0-3.8,0-3.2,0-7.62-.09-12.51s-.13-9.31-.21-12.51c-.05-1.55-.09-2.82-.12-3.8a9.28,9.28,0,0,0-.1-1.39,7.71,7.71,0,0,0-.07,1.39c0,1,0,2.25,0,3.8,0,3.2,0,7.63.09,12.51s.14,9.32.22,12.52c0,1.54.09,2.82.12,3.79A7.7,7.7,0,0,0,247.93,192.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.61 213.28 265.08 211.05 244.45 208.85 235.45 183 193.43 182.71 207.2 212.69 264.61 213.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.36,199.24a2.07,2.07,0,1,0-2.86-.64,2.07,2.07,0,0,0,2.86.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,95.41a5.58,5.58,0,0,0-2,10.3,3,3,0,0,0,2.81.32,3.45,3.45,0,0,0,1.52-2.2,11.78,11.78,0,0,0-.67-8.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.29,146.45h0a9,9,0,0,1-9-9.07c0-3.11.08-5.81.08-5.81s-7.2-.67-7.73-7.8-.3-23.59-.3-23.59h0a24.88,24.88,0,0,1,25.11,1.6l1.1.75-.34,35A9,9,0,0,1,266.29,146.45Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.39,131.47a16.59,16.59,0,0,0,9.14-3.22s-1.88,5.27-9,5.07Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.75,110.41c.14,0,4.52-.62,4.1,4.56s-5.5,3-5.5,2.89S273.75,110.41,273.75,110.41Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.08,116.17s.09.07.24.16a.89.89,0,0,0,.67.06,2.22,2.22,0,0,0,1.19-1.91,3,3,0,0,0-.15-1.32,1,1,0,0,0-.62-.74.45.45,0,0,0-.55.2c-.08.14-.06.25-.09.26s-.1-.1,0-.31a.59.59,0,0,1,.23-.31.67.67,0,0,1,.51-.09,1.26,1.26,0,0,1,.87.88,2.92,2.92,0,0,1,.2,1.46,2.35,2.35,0,0,1-1.49,2.13,1,1,0,0,1-.82-.2C274.08,116.3,274.06,116.18,274.08,116.17Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.3,103.13a20.35,20.35,0,0,0,3.36-2.43,5.45,5.45,0,0,0,8.39,1,2.8,2.8,0,0,0,1.41,2.25,2.77,2.77,0,0,0,2.65,0l.11,8.25a3.77,3.77,0,0,0,.52,2.28,1.31,1.31,0,0,0,2,.17,5.71,5.71,0,0,1,.28-3,2,2,0,0,1,2.49-1.11,20.5,20.5,0,0,0,.29-4.88,4.33,4.33,0,0,1,.2-1.49c.28-.46.41-.11.94-.22a3.69,3.69,0,0,0,2.78-3.33,4.65,4.65,0,0,0-2-4,6.37,6.37,0,0,0-4.42-1.06,2.81,2.81,0,0,0,0-3.76,4.59,4.59,0,0,0-3.76-1.38c-1.39.09-2.95.86-3.12,2.23a5.7,5.7,0,0,0-11.26-.31c-1.66-.74-4-1.55-5.64-.8a5.45,5.45,0,0,0-3.43,4.75s-.42,5.66,3.17,6.8S254.3,103.13,254.3,103.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.26,111.6a1,1,0,0,0,1,1,1,1,0,0,0,1-.9,1,1,0,0,0-1-1A1,1,0,0,0,251.26,111.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,110.47c.12.13.88-.43,2-.42s1.86.54,2,.41-.07-.3-.41-.55a2.78,2.78,0,0,0-1.59-.49,2.65,2.65,0,0,0-1.56.51C251.09,110.18,251,110.42,251,110.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.8,111.85a1,1,0,0,0,1,1,1,1,0,0,0,1-.9,1,1,0,0,0-1-1A1,1,0,0,0,261.8,111.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.62,110.67c.12.14.88-.43,2-.42s1.86.54,2,.41-.07-.3-.41-.55a2.78,2.78,0,0,0-1.59-.49,2.65,2.65,0,0,0-1.56.51C261.67,110.38,261.56,110.62,261.62,110.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.71,118.66a7,7,0,0,0-1.74-.32c-.28,0-.54-.08-.59-.27a1.38,1.38,0,0,1,.19-.81l.81-2.1a36.43,36.43,0,0,0,1.83-5.47,35.78,35.78,0,0,0-2.27,5.31c-.27.74-.53,1.44-.77,2.11a1.56,1.56,0,0,0-.15,1.08.73.73,0,0,0,.45.4,1.72,1.72,0,0,0,.47.06A7.25,7.25,0,0,0,257.71,118.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.88,119.4c-.17,0-.18,1.16-1.18,2s-2.24.7-2.25.86.28.23.8.24a2.86,2.86,0,0,0,1.88-.65,2.56,2.56,0,0,0,.92-1.67C261.09,119.68,261,119.39,260.88,119.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.34,106.46c.11.29,1.18.15,2.44.3s2.29.5,2.46.24-.11-.4-.52-.69a4.09,4.09,0,0,0-1.82-.63,4,4,0,0,0-1.91.22C261.53,106.09,261.3,106.32,261.34,106.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.44,107.36c.19.24.93,0,1.82,0s1.64.16,1.82-.09,0-.37-.37-.6a2.65,2.65,0,0,0-2.94.09C251.46,107,251.35,107.24,251.44,107.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.48,95.07s-.1,0-.28-.08a.92.92,0,0,0-.74.19,1,1,0,0,0-.33,1.08,1.76,1.76,0,0,0,1.07,1.17,2.29,2.29,0,0,0,1.92-.12,2.38,2.38,0,0,0,1.16-1.85,2.66,2.66,0,0,0-.9-2.26,3.16,3.16,0,0,0-2.52-.81,4.11,4.11,0,0,0-2.45,1.22,4.58,4.58,0,0,0-1.17,2.29,6.19,6.19,0,0,0,.73,4.35,7.21,7.21,0,0,0,2,2.28c.59.42,1,.6,1,.64a3.26,3.26,0,0,1-1.06-.47,6.82,6.82,0,0,1-2.25-2.26,6.48,6.48,0,0,1-.88-4.63,5,5,0,0,1,1.28-2.56,4.5,4.5,0,0,1,2.75-1.37,3.67,3.67,0,0,1,2.93.94,3.14,3.14,0,0,1,1,2.69,2.81,2.81,0,0,1-1.43,2.18,2.69,2.69,0,0,1-2.28.08,2,2,0,0,1-1.2-1.44,1.23,1.23,0,0,1,.5-1.32,1,1,0,0,1,.88-.13C253.43,95,253.49,95.06,253.48,95.07Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.05,426c.67-2.66-1.08-5.31-3-7.23s-4.3-3.63-5.33-6.17c-1.67-4.12.51-9.48-2.32-12.9-1.66-2-4.63-2.68-6.1-4.84A11,11,0,0,1,67.9,391,39.36,39.36,0,0,0,58,372.78,34.08,34.08,0,0,0,62,390.38c1.15,2.16,2.56,4.26,2.95,6.68.64,3.92-1.53,8-.55,11.82,1.13,4.4,6.1,7.32,6.36,11.86.22,3.83-3.11,7.22-2.83,11.05a10.32,10.32,0,0,0,1.73,4.54c3,4.91,7.37,8.28,14,8.13l8.09.24Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.05,426c.67-2.66-1.08-5.31-3-7.23s-4.3-3.63-5.33-6.17c-1.67-4.12.51-9.48-2.32-12.9-1.66-2-4.63-2.68-6.1-4.84A11,11,0,0,1,67.9,391,39.36,39.36,0,0,0,58,372.78,34.08,34.08,0,0,0,62,390.38c1.15,2.16,2.56,4.26,2.95,6.68.64,3.92-1.53,8-.55,11.82,1.13,4.4,6.1,7.32,6.36,11.86.22,3.83-3.11,7.22-2.83,11.05a10.32,10.32,0,0,0,1.73,4.54c3,4.91,7.37,8.28,14,8.13l8.09.24Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M93.32,444.9a6.27,6.27,0,0,0,2.22-.06,13.46,13.46,0,0,0,2.63-.68,11.08,11.08,0,0,0,3.23-1.79,4.67,4.67,0,0,0,1.33-1.79,8.28,8.28,0,0,0,.36-2.42,23.7,23.7,0,0,1,.18-2.61,7.09,7.09,0,0,1,1-2.61c.94-1.68,2.52-3.28,3-5.55s.13-4.66-.26-7.09-.77-5.07.14-7.6,2.62-4.83,3.49-7.68.43-6,.6-9a12.1,12.1,0,0,1,1-4.49c.65-1.44,1.55-2.79,2.25-4.3,1.42-3.06,1.65-6.51,2-9.9.18-1.7.37-3.43.55-5.17a26,26,0,0,1,.87-5.18,45.09,45.09,0,0,1,1.91-5,16.88,16.88,0,0,0,.92-2.62,26.81,26.81,0,0,0,.25-2.78,32.82,32.82,0,0,0-.25-5.6c-.23-1.87-.58-3.71-.79-5.58l0-.33,0-.37-.33.17a12.5,12.5,0,0,0-4.33,3.7,19.65,19.65,0,0,0-2.65,4.94c-1.33,3.49-1.8,7.13-2.46,10.61a28.57,28.57,0,0,1-3.27,9.8c-.87,1.44-1.94,2.76-2.87,4.17a11.45,11.45,0,0,0-2,4.62c-.46,3.43,1.44,6.42,1.07,9.45a10.46,10.46,0,0,1-1.45,4.21c-.73,1.29-1.59,2.5-2.4,3.71a23.65,23.65,0,0,0-2.15,3.74,11.93,11.93,0,0,0-1,4.06c-.18,2.73.22,5.31,0,7.76a17.88,17.88,0,0,1-2,6.65c-1,2-2,3.8-3,5.55-.45.88-.87,1.73-1.21,2.59a12.5,12.5,0,0,0-.69,2.56,15.88,15.88,0,0,0,0,4.61,11.65,11.65,0,0,0,2.35,5.88,5.66,5.66,0,0,0,.66.7,3.75,3.75,0,0,0,.53.45c.3.22.47.32.47.32a10,10,0,0,1-1.58-1.54,11.66,11.66,0,0,1-2.23-5.83,15.91,15.91,0,0,1,.08-4.55,12.49,12.49,0,0,1,.7-2.5,26.75,26.75,0,0,1,1.22-2.55c.91-1.74,2-3.54,3-5.54a18.07,18.07,0,0,0,2-6.78c.2-2.49-.19-5.09,0-7.75a11.66,11.66,0,0,1,1-3.93,24.32,24.32,0,0,1,2.13-3.66c.81-1.2,1.68-2.41,2.42-3.74a10.8,10.8,0,0,0,1.52-4.37c.37-3.23-1.51-6.25-1.05-9.43a11.05,11.05,0,0,1,1.92-4.42c.91-1.38,2-2.7,2.89-4.19a29.17,29.17,0,0,0,3.34-10c.67-3.5,1.14-7.1,2.44-10.51a19.3,19.3,0,0,1,2.58-4.82,11.91,11.91,0,0,1,4.15-3.54l-.37-.21,0,.33c.21,1.89.56,3.74.79,5.58a32.93,32.93,0,0,1,.24,5.51c-.05.91-.1,1.85-.23,2.7a15.91,15.91,0,0,1-.9,2.53,47.08,47.08,0,0,0-1.92,5.07,26.16,26.16,0,0,0-.88,5.26c-.18,1.75-.36,3.47-.54,5.18-.37,3.4-.6,6.8-2,9.75-.67,1.46-1.57,2.82-2.24,4.3a12.58,12.58,0,0,0-1,4.67c-.16,3.12.26,6.17-.57,8.94s-2.57,5.06-3.45,7.67-.53,5.37-.13,7.79.81,4.8.3,6.95-2,3.76-2.94,5.48a7.6,7.6,0,0,0-1,2.71,22.42,22.42,0,0,0-.15,2.65,8.06,8.06,0,0,1-.34,2.36,4.29,4.29,0,0,1-1.24,1.7A11,11,0,0,1,98.11,444a14.2,14.2,0,0,1-2.59.72,10.22,10.22,0,0,1-1.64.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.33,349.49a.75.75,0,0,0-.08.24c0,.2-.1.44-.18.73-.15.64-.34,1.6-.63,2.8s-1,2.56-1.66,4.24-1.29,3.58-1.89,5.74-1.14,4.56-1.69,7.13a29.86,29.86,0,0,1-2.55,7.91c-.65,1.32-1.39,2.66-2,4.11a19.06,19.06,0,0,0-1.14,4.65,93,93,0,0,1-1.69,9.79c-1.58,6.64-3.09,13-4.47,18.72s-2.67,10.9-3.74,15.26-1.89,7.82-2.48,10.3c-.28,1.18-.5,2.12-.65,2.8-.07.3-.12.54-.16.74a.79.79,0,0,0,0,.25l.08-.24q.09-.29.21-.72l.74-2.78c.64-2.47,1.54-6,2.64-10.26l3.86-15.24c1.38-5.76,2.91-12.08,4.51-18.72a91.49,91.49,0,0,0,1.68-9.83,18.53,18.53,0,0,1,1.1-4.53c.56-1.42,1.29-2.75,1.94-4.08a30,30,0,0,0,2.54-8c.54-2.57,1-5,1.63-7.12s1.19-4.08,1.8-5.74,1.29-3,1.58-4.28.42-2.19.55-2.84c0-.3.09-.54.12-.74A1.51,1.51,0,0,0,118.33,349.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.74,444.92c5.27-3.17,6.73-12.71,4.49-18.43s-6.12-10.95-6.75-17.06c-.48-4.7,1-9.53-.09-14.12-1.51-6.19-7.6-11-7.56-17.34,0-3.57,2-7,1.85-10.52-.22-4.39-3.61-7.84-5.71-11.69-3.23-5.89-3.48-12.88-4.6-19.5s-3.7-13.7-9.59-16.93C66,325,64.49,328.83,65,336.45c.18,2.73,3.39,7.95,3.85,13.95.28,3.58.48,7.17.72,10.76s.48,7,1.75,10.3c1,2.5,2.53,4.76,3.26,7.34,1.36,4.86-.37,10.13.74,15.05.94,4.17,3.85,7.75,4.47,12,.86,5.94-3,12.14-1,17.8,1,2.8,3.32,5.05,4,7.95.52,2.26,0,4.65.46,6.91.76,3.64,7.74,6.44,11.45,6.19",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.27,324.91a1.54,1.54,0,0,0,0,.32c0,.23.08.54.13.92.12.81.27,2,.55,3.55s1.11,3.29,1.76,5.39,1.37,4.51,2,7.22,1.14,5.71,1.69,8.93a37.29,37.29,0,0,0,2.77,10.09c.75,1.69,1.59,3.37,2.22,5.17a23.16,23.16,0,0,1,1.15,5.7,114.12,114.12,0,0,0,1.62,12.3c1.66,8.32,3.25,16.25,4.69,23.47l4,19.12C92.05,432.5,93,436.9,93.66,440c.33,1.49.59,2.66.78,3.5q.14.55.21.9a1.31,1.31,0,0,0,.09.31,1.11,1.11,0,0,0,0-.32c0-.23-.09-.53-.16-.91-.16-.84-.39-2-.68-3.52-.63-3.08-1.51-7.49-2.61-12.91s-2.45-11.95-3.93-19.15l-4.65-23.46A118,118,0,0,1,81,372.15a23.59,23.59,0,0,0-1.18-5.82c-.66-1.83-1.51-3.52-2.26-5.19a37.52,37.52,0,0,1-2.78-10c-.56-3.22-1.11-6.23-1.75-8.94A73.27,73.27,0,0,0,71,335c-.68-2.11-1.52-3.84-1.84-5.35s-.49-2.71-.65-3.51c-.07-.38-.13-.69-.17-.92A1.87,1.87,0,0,0,68.27,324.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.9,418.38c-1.22,1.74-3.59,1.16-4.69.1a8.88,8.88,0,0,1-2-4.07c-1-3.36-1.94-6.88-1.22-10.29a5.72,5.72,0,0,1,1.31-2.8,3,3,0,0,1,2.83-.94,4.35,4.35,0,0,1,2.48,2.59,24.64,24.64,0,0,1,2.42,10.53,8.46,8.46,0,0,1-1.15,4.88",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M662.9,418.38c-1.22,1.74-3.59,1.16-4.69.1a8.88,8.88,0,0,1-2-4.07c-1-3.36-1.94-6.88-1.22-10.29a5.72,5.72,0,0,1,1.31-2.8,3,3,0,0,1,2.83-.94,4.35,4.35,0,0,1,2.48,2.59,24.64,24.64,0,0,1,2.42,10.53,8.46,8.46,0,0,1-1.15,4.88"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M658.33,427.19a10.51,10.51,0,0,0-6.55-.79,5.43,5.43,0,0,0-3.24,1.44,2.33,2.33,0,0,0,0,3.23,3.06,3.06,0,0,0,2,.52c1.73,0,3.66-.32,5,.72.79.59,1.31,1.58,2.26,1.87a2.22,2.22,0,0,0,2.45-1.09,3.79,3.79,0,0,0,.28-2.81A4.31,4.31,0,0,0,658.33,427.19Z",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.25,420.87a6.3,6.3,0,0,1-1-5.82,11.22,11.22,0,0,1,3.45-5,18.63,18.63,0,0,1,6.19-3.65,6.63,6.63,0,0,1,2.78-.47,2.91,2.91,0,0,1,2.33,1.41c.65,1.24,0,2.75-.65,4a47.12,47.12,0,0,1-4.06,6.19,11,11,0,0,1-4.46,3.82c-1.86.71-3.79.63-4.77-.66",
    style: {
      fill: "#052465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663,444.64a4.26,4.26,0,0,1-.11-.8c0-.57-.12-1.29-.21-2.15a31.63,31.63,0,0,0-.48-3.17,25.06,25.06,0,0,0-1.15-3.74,14.2,14.2,0,0,0-1.91-3.38,7,7,0,0,0-2.41-2,6.77,6.77,0,0,0-2-.64,4,4,0,0,1-.78-.11,3.51,3.51,0,0,1,.8,0,6,6,0,0,1,2.12.55,7.12,7.12,0,0,1,2.54,2,13.38,13.38,0,0,1,2,3.45,23.13,23.13,0,0,1,1.14,3.8,26.43,26.43,0,0,1,.42,3.2c.07.92.1,1.66.11,2.18A3.19,3.19,0,0,1,663,444.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.83,443a2.45,2.45,0,0,1,0-.36c0-.28,0-.63,0-1.05,0-.91,0-2.23-.05-3.86-.08-3.25-.36-7.75-.9-12.69s-1.27-9.38-1.93-12.57c-.16-.8-.31-1.52-.46-2.15s-.26-1.17-.38-1.61l-.24-1a1.41,1.41,0,0,1-.07-.37,1.52,1.52,0,0,1,.13.35l.31,1c.13.44.27,1,.43,1.61s.33,1.34.51,2.14a122.9,122.9,0,0,1,2,12.59c.54,4.95.79,9.45.81,12.72,0,1.63,0,2.95-.06,3.86,0,.43,0,.77-.06,1.05S662.85,443,662.83,443Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.81,434.28a7,7,0,0,1,0-1.09,29.64,29.64,0,0,1,.34-3,38.81,38.81,0,0,1,1-4.33,38.13,38.13,0,0,1,1.81-5.12,27.15,27.15,0,0,1,5.32-8.28,12.83,12.83,0,0,1,1.25-1.16c.19-.16.36-.32.53-.45l.49-.34a6.66,6.66,0,0,1,.92-.59,31.74,31.74,0,0,0-3,2.7,28.78,28.78,0,0,0-5.18,8.25,40.12,40.12,0,0,0-1.82,5.07c-.47,1.59-.79,3-1,4.28s-.35,2.25-.43,2.95A7.52,7.52,0,0,1,662.81,434.28Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.507e6ff5336c3bb20449b89eaf0f06cb.svg";
export { ForwardRef as ReactComponent };